module.exports = __webpack_public_path__ + "img/banner02_en.699fcdf9.jpg";